export default __webpack_public_path__ + "static/media/account-deactived.626b51d9.png";